import { Component, Input } from '@angular/core';
import { BadgeColor } from '../../models/app.models';

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss']
})
export class StatusBadgeComponent {
  @Input() text: string = '';
  @Input() color: BadgeColor = 'gray';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
}

